import React from 'react'
// import { BLOCKS } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import Img from 'gatsby-image'
import styled from 'styled-components'
import Section from '../../common/Section/Section'
import Theme from '../../../vars/ThemeOptions'
 
const Wrap = styled.div`
  .icon-text-sec-wrap {
    display: flex;
    margin: 2rem 0 1rem;
  }
  span {
    b {
      color: ${Theme.hex('primary')};
    }
  }
`

const IconTextWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  :first-of-type {
    margin-right: 6vw;
  }  
  .image-wrap {
    height: 5rem;
    width: 5rem;
    text-align: center;
    .gatsby-image-wrapper {
      height: 100%;
      width: 100%;
    }
    &.icon-3 {
      width: 8.75rem;
    }
  }
  p {
    margin-top: .5rem;
    font-size: 1.3rem;
    font-weight: 600;
  }
`
 
const IdentifyingWindowNeedsSec = ({ data, fixedPricing, eduApproach }) => {
  // console.log("IdentifyingWindowNeedsSec data: ", data)
  const { richText1, shortText1, shortText2 } = data ? data : { data: null }

  // NOTE: Couldn't figure out how to get the code below to recognize the actual data for the embedded entries, so I instead pulled the data for the pieces directly - will try again later, but need to finish this page asap so taking the cheat route for now
  // const options = {
  //   renderNode: {
  //     [BLOCKS.EMBEDDED_ENTRY]: (node, children) => (
  //       <div className="icon-text-wrap">
  //         {console.log("node: ", node)}
  //         {console.log("children: ", children)}
  //         <div className="icon-wrap">
  //           {/* <Img fixed={} alt={} /> */}
  //           icon
  //         </div>
  //         <div className="copy-wrap">
  //           copy  
  //         </div>          
  //       </div>
  //     )
  //   }
  // }
  return (
    <Wrap>
      <Section data={data} padding="1rem 0 3rem 0">
        {richText1 && documentToReactComponents(richText1.json)}
        {/* {richText2 && documentToReactComponents(richText2.json, options)} */}
        <div className="icon-text-sec-wrap">
          {fixedPricing &&
            <IconTextWrap className="pricing">
              <div className="image-wrap">
                <Img fixed={fixedPricing.image.fixed} alt={fixedPricing.title} />                  
              </div>
              <p>{fixedPricing.title}</p>
            </IconTextWrap>
          }
          {eduApproach &&
            <IconTextWrap className="pricing">
              <div className="image-wrap">
                <Img fixed={eduApproach.image.fixed} alt={eduApproach.title} />                  
              </div>
              <p>{eduApproach.title}</p>
            </IconTextWrap>
          }
        </div>
        <span>{shortText1 + ` `}<b>{shortText2}</b></span>
      </Section>
    </Wrap>
  )
}
 
export default IdentifyingWindowNeedsSec